<template lang="html">
  <div class="capsule-details-container">
    <b-row>
      <b-col offset-md="1" sm="12" md="11" class="ml-lg-5">
        <b-row class="mb-3">
          <b-col cols="12">
            <div>
              <div class="actions">
                <capsule-status
                  :status="capsule.status"
                  :publishable="capsule.publishable"
                  :publishedOn="capsule.published_on"
                  class="pb-2"
                />

                <Actions :capsule="capsule" />
              </div>

              <div class="stats pt-4 pb-5">
                <div class="stack">
                  <div class="stack-number">{{ capsule.products_count }}</div>
                  <div class="stack-title">Items</div>
                </div>

                <div class="stack">
                  <div class="stack-number">{{ capsule.outfits_count }}</div>
                  <div class="stack-title">Outfits</div>
                </div>
              </div>
              <div class="capsule-details-title">{{ capsule.title }}</div>
              <div class="capsule-details-occasion">{{ capsule.occasion }}</div>
              <div class="capsule-details-notes">{{ capsule.notes }}</div>
              <div class="capsule-details-link" v-if="capsule.link">
                <i class="pe-7s-link"></i>
                <a
                  class="notes-link"
                  :href="capsule.link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ capsule.link }}
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CapsuleStatus from "@/components/tailor/CapsuleStatus.vue";
import Actions from "@/components/tailor/Actions.vue";

export default {
  props: {
    capsule: {
      type: Object,
      required: true,
    },
  },

  components: {
    CapsuleStatus,
    Actions,
  },

  methods: {
    showBuilderModal() {
      this.$nextTick(() => {
        this.$modal.show("builder-modal", { capsuleData: this.capsule });
      });
    },

    editDetailsModal() {
      this.$nextTick(() => {
        this.$modal.show("edit-details-modal", { capsuleData: this.capsule });
      });
    },

    showPublishModal() {
      this.$nextTick(() => {
        this.$modal.show("confirm-publish-capsule", {
          capsuleId: this.capsule.id,
        });
      });
    },
  },

  computed: {
    hasProducts() {
      const totalProducts = this.capsule.layers.reduce(
        (total, layer) => total + layer.products.length,
        0
      );

      if (totalProducts > 0) {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.actions {
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  // .action-item {
  //   font-size: 24px;
  //   color: $grey3;

  //   &:hover {
  //     color: $primary-blue;
  //   }
  // }
}

.stats {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  .stack {
    text-align: center;

    &:not(:last-child) {
      margin-right: 30px;
    }

    .stack-number {
      color: $grey2;
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
    }
    .stack-title {
      color: $grey3;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 300;
      letter-spacing: 1.4px;
    }
  }
}

.capsule-details-title {
  font-size: 26px;
  line-height: 32px;
}

.capsule-details-occasion {
  padding-top: 3px;
  padding-bottom: 15px;
  letter-spacing: 1.4px;
  line-height: 24px;
  font-weight: 400;
  font-size: 11px;
  text-transform: capitalize;
  color: $grey3;
}

.capsule-details-notes {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  padding-bottom: 15px;
}

.capsule-details-link {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;

  .notes-link {
    text-decoration: none;
    color: $mint-bright;

    &:hover {
      color: darken($mint-bright, 5%);
    }
  }
}

// .published-date {
//   font-size: 11px;
//   font-style: italic;
//   float: right;
//   color: $primary-blue;
//   margin-right: 5px;
//   margin-top: 10px;
// }
</style>



// WEBPACK FOOTER //
// src/components/tailor/CapsuleDetails.vue